// import libs
import React, { useState } from 'react';

// import custom components
import FormattedDate from '../../../../legacy/components/FormattedDate';
// import css
import styles from './ConfirmPanel.css';

const ConfirmPanel = props => {
  const {
    // enableCancel = false,
    me,
    confirmDisable = false,
    onConfirmation,
    confirmPopoverMsg,
  } = props;
  const [dropoverState, setDropover] = useState(false);

  const handleOnButtonClick = () => {
    setDropover(!dropoverState);
  };

  const handleConfirmation = () => {
    setDropover(!dropoverState);
    onConfirmation();
  };
  return (
    <div className={styles.dropoverWrapper}>
      <button
        type="button"
        className={styles.confirmButton}
        onClick={() => handleOnButtonClick()}
        disabled={confirmDisable}
      >
        Confirm
      </button>
      {dropoverState && (
        <div className={styles.confirmDropover}>
          <div className={styles.dropoverContent}>
            <h2>
              <b>
                <FormattedDate
                  overrideLastDay
                  overrideSameDay
                  date={new Date()}
                  me={me}
                />
              </b>
            </h2>
            <p>{confirmPopoverMsg}</p>
          </div>
          <div className={styles.dropoverControls}>
            <button type="button" onClick={() => handleOnButtonClick()}>
              Cancel
            </button>
            <button type="button" onClick={() => handleConfirmation()}>
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmPanel;



// WEBPACK FOOTER //
// ./src/views/components/Common/ConfirmPanel/ConfirmPanel.jsx